export const CATEGORIAS_EVENTO = [
  { value: "salida",   label: "Salida",          color: "#16a34a", bg: "#dcfce7", icono: "🏕️" },
  { value: "normal",   label: "Actividad normal", color: "#b45309", bg: "#fef9c3", icono: "⭐" },
  { value: "sin",      label: "Sin actividades",  color: "#991b1b", bg: "#fee2e2", icono: "🚫" },
  { value: "especial", label: "Especial",         color: "#1d4ed8", bg: "#dbeafe", icono: "💫" },
  { value: "otros",    label: "Otros",            color: "#be185d", bg: "#fce7f3", icono: "📌" },
]
